const componentName = 'payment';
const serviceName = 'DoctorPaymentRealtimeComponent';
const moduleName = 'doxy.realtime.components.doctor-payment';
export { componentName, serviceName, moduleName };
import DoctorPaymentRealtimeComponent from './doctor/payment';
import selectAmount from './doctor/doctor-pay-popup/select-amount/select-amount';
import paymentStatus from './doctor/doctor-pay-popup/payment-status/payment-status';

export default angular
  .module(moduleName, [selectAmount, paymentStatus])
  .service(serviceName, DoctorPaymentRealtimeComponent).name;
